import PropTypes from 'prop-types';

export const AutoCompleteOptionType = PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.elementType, PropTypes.object]),
});
